var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEtherumCoinRouded(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    fill: "none",
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M54.25 28C54.25 13.503 42.498 1.75 28 1.75S1.75 13.503 1.75 28 13.503 54.25 28 54.25 54.25 42.498 54.25 28"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#e3e3fa",
    d: "M35.875 29.931c-.036-.002-8.21 4.986-8.317 5.029-.024-.014-8.269-5.04-8.308-5.035.02.03 8.303 12.075 8.308 12.075.006 0 8.317-12.069 8.317-12.069"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#e3e3fa",
    d: "m27.562 14-8.285 14.272 8.285 5.055 8.286-5.055z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 56,
    x2: 0,
    y1: 0,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4e53b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#929fe7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d529f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtherumCoinRouded);
export default __webpack_public_path__ + "static/media/etherumCoinRouded.30c2f7bcb0fa8d8b86db1adfed4f63aa.svg";
export { ForwardRef as ReactComponent };